import React from 'react';
import { Swords } from 'lucide-react';

const Lado = ({ nome, avatar, clan, lado, cor }) => (
  <div className={`flex min-w-0 flex-1 flex-col items-center gap-2 ${lado === 'dir' ? 'md:items-end' : 'md:items-start'}`}
    data-testid={`gb-duel-${lado}`}>
    <div className="relative">
      <span className="absolute -inset-1.5 animate-pulse rounded-full opacity-60 blur-md"
        style={{ background: cor }} />
      {avatar ? (
        <img src={avatar} alt={nome} className="relative h-16 w-16 rounded-full border-2 object-cover sm:h-20 sm:w-20"
          style={{ borderColor: cor }} />
      ) : (
        <span className="relative flex h-16 w-16 items-center justify-center rounded-full border-2 bg-black/60 text-2xl font-black sm:h-20 sm:w-20"
          style={{ borderColor: cor, color: cor }}>{(nome || '?').slice(0, 1)}</span>
      )}
    </div>
    <div className="max-w-[40vw] text-center">
      <p className="truncate text-sm font-black text-purple-50 sm:text-base">{nome || 'Oponente'}</p>
      {(clan?.name || clan?.medal_img) && (
        <span className="mt-1 inline-flex max-w-full items-center gap-1 rounded-full border px-1.5 py-[1px]"
          style={{ borderColor: `${cor}88`, background: `${cor}1a` }}>
          {clan.medal_img && <img src={clan.medal_img} alt="" className="h-4 w-4 flex-none object-contain" />}
          {clan.name && <span className="truncate text-[10px] font-black" style={{ color: cor }}>{clan.name}</span>}
        </span>
      )}
    </div>
  </div>
);

export const GbDuelLoader = ({ pct, eu, rival, titulo }) => (
  <div className="absolute inset-0 z-10 flex flex-col items-center justify-center overflow-hidden bg-[#0b0712]"
    data-testid="gb-duel-loader">
    <img src="/gb/duel_bg.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-70" />
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(11,7,18,.55)_20%,rgba(11,7,18,.95)_85%)]" />

    <div className="relative w-full max-w-3xl px-6">
      <p className="mb-1 text-center text-[11px] font-black uppercase tracking-[.35em] text-orange-300/90">
        {titulo}
      </p>
      <div className="mt-4 flex items-center gap-3 sm:gap-8">
        <Lado nome={eu?.nickname} avatar={eu?.avatar} lado="esq" cor="#67e8f9"
          clan={{ name: eu?.clan_name, medal_img: eu?.medal_img }} />
        <div className="flex flex-col items-center gap-1">
          <Swords className="h-7 w-7 animate-pulse text-orange-400 drop-shadow-[0_0_14px_rgba(255,107,0,.8)] sm:h-9 sm:w-9" />
          <span className="text-xl font-black italic text-orange-300 sm:text-2xl">VS</span>
        </div>
        <Lado nome={rival?.nickname} avatar={rival?.avatar} lado="dir" cor="#fb7185"
          clan={{ name: rival?.clan_name, medal_img: rival?.medal_img }} />
      </div>

      <div className="mx-auto mt-10 w-full max-w-md">
        <div className="h-2.5 w-full overflow-hidden rounded-full border border-purple-800/70 bg-black/60">
          <div className="h-full rounded-full bg-gradient-to-r from-orange-500 via-amber-400 to-orange-500 transition-all duration-300"
            style={{ width: `${Math.min(100, Math.max(3, pct))}%` }} data-testid="gb-duel-bar" />
        </div>
        <div className="mt-2 flex items-center justify-between text-[11px] font-black tracking-wide text-purple-200/80">
          <span>{pct >= 100 ? 'ENTRANDO NA ARENA…' : 'PREPARANDO O TERRENO…'}</span>
          <span className="font-mono text-amber-300" data-testid="gb-duel-pct">{Math.min(100, Math.round(pct))}%</span>
        </div>
      </div>
    </div>
  </div>
);
